// Template Layout
import ManagementLayout from "./ManagementLayout";

// Routes
import { userRoutes } from "./modules/users/routes";
import { projectRoutes } from "./modules/projects/routes";
import { messagingRoutes } from "./modules/messaging/routes";
import { lineNotifyRoute } from "./modules/line-notify/routes"

// Components
import QRCheckin from "@/components/QRCheckin";

export const managementRoutes = {
  path: "management",
  component: ManagementLayout,
  children: [
    {
      path: "qrcheckin",
      name: "QRCheckin",
      component: QRCheckin
    },
    ...userRoutes(),
    ...projectRoutes(),
    ...messagingRoutes(),
    lineNotifyRoute
  ]
};



// WEBPACK FOOTER //
// ./src/features/managements/routes.js